import { render } from "./WidgetContainer.vue?vue&type=template&id=21e28e0d&scoped=true"
import script from "./WidgetContainer.vue?vue&type=script&lang=js"
export * from "./WidgetContainer.vue?vue&type=script&lang=js"

import "./WidgetContainer.vue?vue&type=style&index=0&id=21e28e0d&scoped=true&lang=css"
import "./WidgetContainer.vue?vue&type=style&index=1&id=21e28e0d&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e28e0d"]])

export default __exports__